import store from '@/store';

const permissionChecker = () => store.getters['auth/profile']?.appCodes?.includes('AUTH');

export default [
    {
        path: '/customers',
        name: 'customers.index',
        component: () => import(/* webpackChunkName: "CustomersList" */ '@/views/auth/customers/CustomersList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'customers',
            title: 'customers',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            flowStartsWith: 'customers.index',
            product: 'qxt-admin',
            permissionChecker,
        },
    },
    {
        path: '/customers/create',
        name: 'customers.create',
        component: () => import(/* webpackChunkName: "CustomersCreate" */ '@/views/auth/customers/CustomersCreate'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'add new',
            title: 'add new customer',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            flowStartsWith: 'customers.create',
            product: 'qxt-admin',
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId',
        name: 'customers.edit',
        component: () => import(/* webpackChunkName: "CustomersEdit" */ '@/views/auth/customers/CustomersEdit'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'edit customer',
            title: 'edit customer',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN', 'CUSTOMER_ADMIN'],
            hideFromSearch: true,
            permissionChecker,
        },
    },
    // Deleted customers
    {
        path: '/deleted-customers',
        name: 'customers.deletedCustomers.index',
        component: () =>
            import(/* webpackChunkName: "DeletedCustomersList" */ '@/views/auth/customers/deletedCustomers/DeletedCustomersList'),
        meta: {
            loadInModal: true,
            actions: false,
            title: 'deleted customers',
            breadcrumbName: 'deleted customers',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/deleted-customers/:customerId/details',
        name: 'customers.deletedCustomers.details',
        component: () => import(/* webpackChunkName: "CustomerDetails" */ '@/views/auth/customers/CustomerDetails'),
        meta: {
            loadInModal: true,
            actions: false,
            title: 'deleted customer details',
            breadcrumbName: 'deleted customer details',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            hideFromSearch: true,
            permissionChecker,
        },
    },
    // Communities
    {
        path: '/customers/:customerId/communities',
        name: 'customer.communities.index',
        component: () => import(/* webpackChunkName: "CommunitiesList" */ '@/views/auth/customers/communities/CommunitiesList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'communities',
            title: 'manage company communities',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.communities.index',
            product: 'qxt-admin',
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/communities/import',
        name: 'customer.communities.import',
        component: () => import(/* webpackChunkName: "CommunitiesImportView" */ '@/views/auth/customers/communities/CommunitiesImportView'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'import communities',
            title: 'import communities',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            flowStartsWith: 'customer.communities.index',
            passFlowTo: 'customer.communities.index',
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/communities/create',
        name: 'customer.communities.create',
        component: () => import(/* webpackChunkName: "CommunitiesCreate" */ '@/views/auth/customers/communities/CommunitiesCreate'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'add new',
            title: 'add new community',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.communities.create',
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/communities/:communityId',
        name: 'customer.communities.edit',
        component: () => import(/* webpackChunkName: "CommunitiesEdit" */ '@/views/auth/customers/communities/CommunitiesEdit'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'community details',
            title: 'community details',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            hideFromSearch: true,
            permissionChecker,
        },
    },
    // Deleted communities
    {
        path: '/customers/:customerId/deleted-communities',
        name: 'customer.deletedCommunities.index',
        component: () =>
            import(/* webpackChunkName: "DeletedCommunitiesList" */ '@/views/auth/customers/deletedCommunities/DeletedCommunitiesList'),
        meta: {
            loadInModal: true,
            actions: false,
            title: 'archived communities',
            breadcrumbName: 'archived communities',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/deleted-communities/:communityId/details',
        name: 'customer.deletedCommunities.details',
        component: () => import(/* webpackChunkName: "CommunityDetails" */ '@/views/auth/customers/communities/CommunityDetails'),
        meta: {
            loadInModal: true,
            actions: false,
            title: 'archived community details',
            breadcrumbName: 'archived community details',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            hideFromSearch: true,
            permissionChecker,
        },
    },
    // Users
    {
        path: '/customers/:customerId/users',
        name: 'customer.users.index',
        component: () => import(/* webpackChunkName: "UsersList" */ '@/views/auth/customers/users/UsersList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'users',
            title: 'manage company users',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.users.index',
            product: 'qxt-admin',
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/users/create',
        name: 'customer.users.create',
        component: () => import(/* webpackChunkName: "UsersCreate" */ '@/views/auth/customers/users/UsersCreate'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'add new',
            title: 'add new company user',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.users.create',
            product: 'qxt-admin',
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/users/:userId/reinvite',
        name: 'customer.users.invite.index',
        component: () => import(/* webpackChunkName: "UsersEdit" */ '@/views/auth/customers/users/UserReinviteView'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 're-invite',
            title: 'resend invitation',
            allowedRoles: ['SUPER_ADMIN'],
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/users/:userId',
        name: 'customer.users.edit',
        component: () => import(/* webpackChunkName: "UsersEdit" */ '@/views/auth/customers/users/UsersEdit'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'edit',
            title: 'edit user',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/users/:userId/details',
        name: 'customer.users.details',
        component: () => import(/* webpackChunkName: "UsersEdit" */ '@/views/auth/customers/users/UserDetails'),
        meta: {
            loadInModal: true,
            actions: true,
            title: 'user details',
            breadcrumbName: 'user details',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            hideFromSearch: true,
            permissionChecker,
        },
    },
    // Deleted users
    {
        path: '/customers/:customerId/deleted-users',
        name: 'customer.deletedUsers.index',
        component: () => import(/* webpackChunkName: "DeletedUsersList" */ '@/views/auth/customers/deletedUsers/DeletedUsersList'),
        meta: {
            loadInModal: true,
            actions: true,
            title: 'company deleted users',
            breadcrumbName: 'deleted users',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/deleted-users/:userId/details',
        name: 'customer.deletedUsers.details',
        component: () => import(/* webpackChunkName: "UsersEdit" */ '@/views/auth/customers/users/UserDetails'),
        meta: {
            loadInModal: true,
            actions: false,
            title: 'deleted user details',
            breadcrumbName: 'deleted user details',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            hideFromSearch: true,
            permissionChecker,
        },
    },
    // Admins
    {
        path: '/customers/:customerId/admins',
        name: 'customer.admins.index',
        component: () => import(/* webpackChunkName: "AdminsList" */ '@/views/auth/customers/admins/AdminsList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'admins',
            title: 'manage company admins',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.admins.index',
            product: 'qxt-admin',
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/admins/create',
        name: 'customer.admins.create',
        component: () => import(/* webpackChunkName: "UsersCreate" */ '@/views/auth/customers/users/UsersCreate'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'add new',
            title: 'add new company admin',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.admins.create',
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/admins/:userId/reinvite',
        name: 'customer.admins.invite.index',
        component: () => import(/* webpackChunkName: "UsersEdit" */ '@/views/auth/customers/users/UserReinviteView'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 're-invite',
            title: 'resend invitation',
            allowedRoles: ['SUPER_ADMIN'],
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/admins/:userId',
        name: 'customer.admins.edit',
        component: () => import(/* webpackChunkName: "UsersEdit" */ '@/views/auth/customers/users/UsersEdit'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'edit',
            title: 'edit admin',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/admins/:userId/details',
        name: 'customer.admins.details',
        component: () => import(/* webpackChunkName: "UsersDetails" */ '@/views/auth/customers/users/UserDetails'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'admin details',
            title: 'admin details',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/deleted-admins',
        name: 'customer.deletedAdmins.index',
        component: () => import(/* webpackChunkName: "DeletedAdminsList" */ '@/views/auth/customers/admins/DeletedAdminsList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'deleted admins',
            title: 'deleted admins',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.admins.index',
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/deleted-admins/:userId/details',
        name: 'customer.deletedAdmins.details',
        component: () => import(/* webpackChunkName: "UsersDetails" */ '@/views/auth/customers/users/UserDetails'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'admin details',
            title: 'deleted admin details',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            hideFromSearch: true,
            permissionChecker,
        },
    },
    // Roles
    {
        path: '/customers/:customerId/roles',
        name: 'customer.roles.index',
        component: () => import(/* webpackChunkName: "RolesList" */ '@/views/auth/customers/roles/RolesList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'roles',
            title: 'manage company roles',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.roles.index',
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/roles/:roleId/details',
        name: 'customers.roles.details',
        component: () => import(/* webpackChunkName: "RoleDetails" */ '@/views/auth/customers/roles/RoleDetails'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'role details',
            title: 'role details',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            hideFromSearch: true,
            permissionChecker,
        },
    },
    // Deleted roles
    {
        path: '/customers/:customerId/deleted-roles',
        name: 'customer.deletedRoles.index',
        component: () => import(/* webpackChunkName: "DeletedRolesList" */ '@/views/auth/customers/roles/DeletedRolesList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'deleted roles',
            title: 'deleted company roles',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.roles.index',
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/deleted-roles/:roleId/details',
        name: 'customer.deletedRoles.details',
        component: () => import(/* webpackChunkName: "RoleDetails" */ '@/views/auth/customers/roles/RoleDetails'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'deleted role details',
            title: 'deleted role details',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            hideFromSearch: true,
            permissionChecker,
        },
    },
    // Permissions
    {
        path: '/customers/:customerId/permissions',
        name: 'customer.permissions.index',
        component: () => import(/* webpackChunkName: "PermissionsList" */ '@/views/auth/customers/permissions/PermissionsList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'permissions',
            title: 'manage company permissions',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.permissions.index',
            hideFromSearch: true,
            permissionChecker,
        },
    },
    {
        path: '/customers/:customerId/deleted-permissions',
        name: 'customer.deletedPermissions.index',
        component: () =>
            import(/* webpackChunkName: "DeletedPermissionsList" */ '@/views/auth/customers/permissions/DeletedPermissionsList'),
        meta: {
            loadInModal: true,
            actions: true,
            breadcrumbName: 'deleted permissions',
            title: 'deleted company permissions',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            flowStartsWith: 'customers.index',
            passFlowTo: 'customer.permissions.index',
            hideFromSearch: true,
            permissionChecker,
        },
    },
    //  Community Integrations
    {
        path: '/customers/:customerId/communities/:communityId/integrations',
        name: 'customer.communities.integrations.index',
        component: () =>
            import(
                /* webpackChunkName: "CustomerIntegrationsList" */ '@/views/auth/customers/communities/Integrations/CustomerIntegrationsList'
            ),
        meta: {
            loadInModal: true,
            actions: true,
            title: 'integration partners',
            breadcrumbName: 'integration partners',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            flowStartsWith: 'customer.communities.index',
            passFlowTo: 'customer.communities.integrations.index',
            hideFromSearch: true,
            requiredAppAccess: ['IPS'],
        },
    },
    {
        path: '/customers/:customerId/communities/:communityId/integrations/create',
        name: 'customer.communities.integrations.create',
        component: () =>
            import(
                /* webpackChunkName: "CustomerIntegrationsCreate" */ '@/views/auth/customers/communities/Integrations/CustomerIntegrationsCreate'
            ),
        meta: {
            loadInModal: true,
            actions: true,
            title: 'add integration partner',
            breadcrumbName: 'add new',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            flowStartsWith: 'customer.communities.index',
            passFlowTo: 'customer.communities.integrations.create',
            hideFromSearch: true,
            requiredAppAccess: ['IPS'],
        },
    },
    {
        path: '/customers/:customerId/communities/:communityId/integrations/:partnerId',
        name: 'customer.communities.integrations.edit',
        component: () =>
            import(
                /* webpackChunkName: "CustomerIntegrationsEdit" */ '@/views/auth/customers/communities/Integrations/CustomerIntegrationsEdit'
            ),
        meta: {
            loadInModal: true,
            actions: true,
            title: 'edit integration partner',
            breadcrumbName: 'edit integration partner',
            allowedRoles: ['SUPER_ADMIN', 'SUPER_READONLY_ADMIN'],
            hideFromSearch: true,
            requiredAppAccess: ['IPS'],
        },
    },
];
